import { buildContext } from '@toss/react';

import type { SearchQuizsetRes } from '@/api/gen/_model/searchQuizsetRes';
import { type QuizListType } from '@/shared/quizList/QuizListType';

import { type QuizCardMenuItem } from './useGetQuizListItemButtons';

export type QuizListItemProps = {
  alwaysDropDownMenu: boolean;
  quizSet: SearchQuizsetRes;
  menuItems: QuizCardMenuItem[];
  isHideAuthor: boolean;
  subjectName: string | undefined;
  eventLocation: QuizListType;
  eventAdditionalProperty?: Partial<
    Record<QuizListType, Record<string, unknown>>
  >;
  /**
   * 이 목록이 재생 맥락으로서 속한 폴더. 있으면 행에서 시작한 재생이 폴더 재생으로 이어진다.
   *
   * ⚠️ `quizSet.folderId`(그 퀴즈가 어디에 담겨 있나)와 다른 질문이다. 합치면 폴더 밖에서 연 퀴즈까지
   * 폴더 재생이 된다.
   */
  folderPlayOrigin?: string;
};

export const [QuizListItemProvider, useQuizListItemProvider] =
  buildContext<QuizListItemProps>('BuildContext', null);
